<template>
    <div class="page-container">
        <!-- 省市区 -->
        <van-area :hidden="!showArea" @cancel="showArea = false" @confirm="confirmArea" title="请选择省市区" :area-list="areaList" />

        <div class="page-section">
            <div class="info-section">
                <div class="section-title">基本信息</div>
                <div class="input-grp">
                    <van-field v-model="name" :border='false' label="姓名" placeholder="请输入姓名" />
                    <van-field v-model="phone" :border='false' label="手机号" placeholder="请输入手机号" />
                </div>
            </div>
            <div class="info-section">
                <div class="section-title">地址信息</div>
                <div class="input-grp">
                    <van-field v-model="area" :disabled="true" @click="showArea = true" :border='false' label="地区" placeholder="请选择省/市/区" />
                    <van-field v-model="addressDetail" :border='false' label="地址" placeholder="请输入详细地址" />
                </div>
            </div>
        </div>
        <div class="page-section">
            <div class="info-section">
                <div class="section-title">备注</div>
                <van-field
                    v-model="remarks"
                    rows="1"
                    autosize
                    type="textarea"
                    placeholder="请输入备注"
                />
            </div>
        </div>

        <div class="btn-confirm">确认新增</div>
    </div>
</template>
<script>
import { Field,Area } from 'vant'
import areaList from '../../lib/area'
import $http from '@/lib/request'
import config from '@/config'

export default {
    data(){
        return {
            name:'',
            phone:'',
            addressDetail:'',
            area:'',
            areaList:areaList,
            showArea:false,
            remarks:'',//备注
            id:'',//地址id
        }
    },
    components:{
        [Field.name]:Field,
        [Area.name]:Area
    },
    activated(){
        this.id=this.$route.params.id;
        $http({
            method:'post',
            data:{
                id:this.id
            },
            url:config.api.getAddDetail
        }).then(res=>{
            if(res.errno == 0){
                // let addressInfo=res.data;
                // this.name=addressInfo.name;

            }else{
                Toast(res.errmsg);
            }
        })
    },
    methods:{
        confirmArea(result){
            let areastr=result[0].name + '/' + result[1].name + '/' + result[2].name;
            this.area=areastr;
            this.showArea=false;
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .van-cell{
    padding-left:0;
    padding-right: 0;
}
::v-deep .van-field--disabled .van-field__label{
    color:#646566!important;
}
::v-deep .van-picker{
    box-shadow: 0 -1px 5px 0 #eee;
    position:fixed;
    left:0;
    bottom:0;
    width:100vw;
    z-index: 9;
}
.page-container{
    min-height:calc(100vh - 46px);
    box-sizing: border-box;
    padding:15px 10px;
    padding-bottom: 70px;
    background:#fafafa;
    .page-section{
        padding:15px;
        background:#fff;
        margin-bottom: 15px;
        @media screen and (max-width:750px){
            border-radius: 4px;
        }
        .info-section{
            border-bottom: 1px dashed #f0f0f0;
            margin-bottom: 15px;
            &:last-child{
                border-bottom: none;
                margin-bottom: 0;
            }
            .section-title{
                color:#333;
                font-size: 17px;
                line-height: 24px;
                margin-bottom: 5px;
            }
        }
    }

    .btn-confirm{
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        font-size: 14px;
        color:#fff;
        position: fixed;
        bottom:26px;
        left:50%;
        transform: translateX(-50%);
        @media screen and (max-width:750px){
            border-radius: 26px;
        }
    }
}
</style>